import React, { useState } from "react";

import {
  createParticipant,
  fetchParticipants,
  generatePassword,
} from "@services/api";
import { useAppStore } from "@store/appStateStore";

const AddParticipantForm: React.FC = () => {
  const { setParticipants } = useAppStore();

  const [name, setName] = useState("");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [payload, setPayload] = useState("");

  const [error, setError] = useState("");

  const handleLoginSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Пожалуйста, введите имя участника");
      return;
    }

    try {
      await createParticipant(name);

      const participants = await fetchParticipants();
      setParticipants(participants);
      setName("");
    } catch (error) {
      console.error("Ошибка при добавлении участника:", error);
      alert("Не удалось добавить участника");
    }
  };

  const handleGenerateSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();

    try {
      const result = await generatePassword(username, password, payload);
      if (result.success) {
        console.log(result);
      } else {
        console.log(result);
        setError("Ошибка авторизации: " + result.message);
      }
    } catch (err) {
      setError("Ошибка авторизации: " + err);
      console.error("Ошибка авторизации:", err);
    }
  };

  return (
    <>
      <form style={{ paddingBottom: "1rem" }} onSubmit={handleLoginSubmit}>
        <div>
          <input
            id="participantName"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Введите имя"
            required
            className="control"
          />
        </div>
        <button type="submit" className="control">
          Добавить участника
        </button>
      </form>
      <form onSubmit={handleGenerateSubmit}>
        <div>
          <input
            type="text"
            placeholder="Логин"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="control"
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="control"
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="Строка для проверки"
            value={payload}
            onChange={(e) => setPayload(e.target.value)}
            className="control"
          />
        </div>
        <div>
          <button type="submit" className="control">
            Проверить
          </button>
        </div>
        {error && <div className="error">{error}</div>}
      </form>
    </>
  );
};

export default AddParticipantForm;
